import {SORT} from '../incase-domain/common/sort.enum';

export interface ListParamsDefaults {
    page: number;
    size: number;
    search: string;
}

export const LIST_PARAMS_DEFAULTS: ListParamsDefaults = {
    page: 1,
    size: 10,
    search: '',
};

export interface ListParams {
    page: number;
    size: number;
    search: string;
    sortBy: Record<string, SORT>;
    filters: Record<string, string>;
}

export type SetListParamsOptions = {
    replace?: boolean;
    resetPage?: boolean;
};

export interface UseListParamsReturn {
    listParams: ListParams;
    setListParams: (partial: Partial<ListParams>, options?: SetListParamsOptions) => void;
}

export function createListParams(params: Partial<ListParams> = {}): ListParams {
    return {
        page: params.page ?? LIST_PARAMS_DEFAULTS.page,
        size: params.size ?? LIST_PARAMS_DEFAULTS.size,
        search: params.search ?? LIST_PARAMS_DEFAULTS.search,
        sortBy: params.sortBy ?? {},
        filters: params.filters ?? {},
    };
}

export interface DataViewListStateProps {
    search?: string;
    filterValues?: Record<string, string>;
    sortBy?: Record<string, SORT>;
    onPageChange?: (page: number) => void;
    onSearchChange?: (search: string) => void;
    onFiltersChange?: (filters: Record<string, string>) => void;
    onSortChange?: (sortBy: Record<string, SORT>) => void;
}

export function createDataViewListStateProps(
    listParams: ListParams,
    setListParams: (partial: Partial<ListParams>, options?: SetListParamsOptions) => void
): DataViewListStateProps {
    return {
        search: listParams.search,
        filterValues: listParams.filters,
        sortBy: listParams.sortBy,
        onPageChange: (page) => setListParams({page}),
        onSearchChange: (search) => setListParams({search}, {resetPage: true}),
        onFiltersChange: (filters) => setListParams({filters}, {resetPage: true}),
        onSortChange: (sortBy) => setListParams({sortBy}),
    };
}
